export default {
      id: "tooltip-usage",
      viewBox: "0 0 36.614 36.613",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#tooltip",
      toString: function () {
        return this.url;
      }
    }